import { inputEventHandler } from './eventHandlers';
import { KEY_CODES } from '../../utils/shared/accessibilityUtils';

const { enter } = KEY_CODES;

export const confirmHandler = ({
    keyCode,
    mouseClick,
    wordPosition,
    inputType,
    wordValue,
    setWordEvent,
}) => {
    if ((keyCode === enter || mouseClick) && inputType) {
        inputEventHandler(wordValue, wordPosition, inputType, setWordEvent);
    }
};

export const onEscHandler = (keyCode, toolbarType, closeToolbarHandler) => {
    if (toolbarType && keyCode === KEY_CODES.esc) {
        closeToolbarHandler();
    }
};

export const getToolbarPosition = (isEndTime, wordReference, parentReference) => {
    const widthToolbar = 260;
    const heightToolbar = isEndTime ? 190 : 60;
    const wordContainerPadding = 10;
    const triangleWidth = 5;
    const padding = 20;
    const blueBorder = '2px solid #1e4878';
    const triangleBorder = '5px solid #1e4878';
    const borderNone = 'none';

    const targetWord = {
        width: wordReference.current.clientWidth,
        height: wordReference.current.clientHeight,
        left: wordReference.current.offsetLeft,
        top: wordReference.current.offsetTop,
        right:
            parentReference.current.clientWidth -
            wordReference.current.offsetLeft -
            wordReference.current.offsetWidth,
    };

    const parentContainer = {
        width: parentReference.current.clientWidth,
        height: parentReference.current.clientHeight,
    };

    const toolbar = {
        width: widthToolbar,
        height: heightToolbar,
        left: targetWord.left + targetWord.width / 2 - widthToolbar / 2,
        top: targetWord.top + targetWord.height - wordContainerPadding,
        right: targetWord.left + targetWord.width / 2 - widthToolbar / 2 + widthToolbar,
        bottom: targetWord.top + targetWord.height + heightToolbar,
        borderTop: blueBorder,
        borderBottom: borderNone,
    };

    const triangle = {
        marginLeft: `${toolbar.width / 2 - triangleWidth}px`,
        borderBottom: triangleBorder,
        isTopTriangle: true,
    };

    // Left and right toolbar positioning logic
    if (toolbar.left < padding) {
        toolbar.left = padding;
        triangle.marginLeft = targetWord.left + targetWord.width / 2 - triangleWidth - padding;
    } else if (parentContainer.width - padding < toolbar.right) {
        const difference = toolbar.right - (parentContainer.width - padding);

        toolbar.left -= difference;
        triangle.marginLeft =
            toolbar.width - targetWord.right - targetWord.width / 2 - triangleWidth + padding;
    }

    // Top toolbar positioning logic
    if (parentContainer.height - padding < toolbar.bottom) {
        toolbar.top -= targetWord.height + heightToolbar;
        toolbar.borderTop = borderNone;
        toolbar.borderBottom = blueBorder;

        triangle.borderTop = triangleBorder;
        triangle.borderBottom = borderNone;
        triangle.isTopTriangle = false;
    }

    return {
        position: {
            left: `${toolbar.left}px`,
            top: `${toolbar.top}px`,
        },
        toolbar: {
            borderTop: toolbar.borderTop,
            borderBottom: toolbar.borderBottom,
        },
        trianglePosition: {
            ...triangle,
        },
        isTopTriangle: triangle.isTopTriangle,
    };
};
